import * as React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { ErrorPage } from '@web-config-app/core-react-ui';
import { useConfigAppPath } from '@web-config-app/core-react';

/**
 * Redirects from non-locale entity details routes to locale entity details routes
 */
export const EntityDetailsRedirect = () => {
  const { tabId, moduleId, childModuleId, environmentKey, entityInstanceId } =
    useParams<{
      tabId: string;
      moduleId: string;
      childModuleId: string;
      environmentKey: string;
      entityInstanceId: string;
    }>();

  const generateConfigPaths = useConfigAppPath();

  const { getEntityDetailsPathForId } = generateConfigPaths({
    tabId,
    moduleId,
    childModuleId,
    environmentKey,
  });

  if (!entityInstanceId) {
    return <ErrorPage />;
  }

  return <Navigate to={getEntityDetailsPathForId(entityInstanceId)} replace />;
};
